import { useUserStore } from '../../store/useUserStore';
import { useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import moment from 'moment';

import { SELECT_STYLE } from '../../data/define';
import { calculateAge } from '../../utility/utilities';
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import ImgHeader from '../../assets/image/report/img_report_header.png';
import IcAlert from '../../assets/image/ic_!_mint.svg';
import IcAlertRed from '../../assets/image/ic_!_red.svg';
import OneBtnAlert from '../common/OneBtnAlert';
import { useTranslation } from '../../hook/useTranslation';

const ComparisonType = {
  Previous: 1,
  Cumulative: 2,
};

const TabCase = {
  Result: 1,
  Change: 2,
};

function Header({
  reports = [],
  selectedReportId = null,
  setSelectedReportId = () => {},
  tab = TabCase.Result,
  setTab = () => {},
  changeToggle = ComparisonType.Previous,
  lastReportId = null,
  setLastReportId = () => {},
  filteredReports = [],
  shouldShowLackVideo = false,
  shouldShowMoreVideo = false,
}: any) {
  const navigate = useNavigate();
  const location = useLocation();
  const { t } = useTranslation();
  const user = useUserStore();
  const [alertOpen, setAlertOpen] = useState(false);

  return (
    <div className="w-[calc(100%+40px)] -mx-[20px] relative bg-[#d4f4f5]">
      <img
        src={ImgHeader}
        alt="thumnail1"
        className="absolute right-[20px] top-[-10px] w-[150px] object-contain"
      />
      <div className="w-full h-[120px] flex items-center justify-start gap-[16px] px-[20px] pt-[20px]">
        <div className="w-[64px] h-[64px] border border-[#EAEAEA] rounded-[24px] bg-[#fff] flex justify-center items-center overflow-hidden">
          {user?.mainKid?.imageUrl && (
            <img
              src={user?.mainKid?.imageUrl}
              alt="kid profile"
              className="w-[64px] h-[64px] object-cover"
            />
          )}
        </div>
        <div className="grow flex flex-col items-start my-[12px]">
          <div className="flex items-center gap-[5px]">
            <span className="text-sm font-[700] text-[20px]">{user?.mainKid?.kidName}</span>
          </div>
          <div className="text-[14px] font-[400] text-gray-400">
            <span>{user?.mainKid?.gender === 'male' ? t('home.male') : t('home.female')}</span>•
            {/* 첫째 */}
            {t('common.age', { age: calculateAge(user?.mainKid?.kidBirth) })}
          </div>
        </div>
      </div>
      <div className=" h-[40px] mt-[12px] mb-[43px] px-[20px] flex items-center justify-start">
        {reports.length > 0 && (
          <Select
            variant="outlined"
            value={selectedReportId || ''}
            onChange={(e) => {
              setSelectedReportId(e.target.value);
              navigate(
                { pathname: location.pathname, search: `?reportId=${e.target.value}` },
                { replace: true }
              );
            }}
            renderValue={(selected) => (
              <>
                <span style={{ color: '#969696', fontWeight: 600 }}>
                  {t('community.write.view_date')}&nbsp;
                </span>
                <span style={{ color: '#363636', fontWeight: 700 }}>
                  {reports.length > 0 ? (
                    <>
                      {moment(reports.find((report) => report.id === selected)?.updatedAt).format(
                        'YY.MM.DD'
                      ) || t('community.write.no_report_selected')}
                    </>
                  ) : (
                    <>...</>
                  )}
                </span>
              </>
            )}
            IconComponent={KeyboardArrowDownIcon}
            sx={{ ...SELECT_STYLE, backgroundColor: '#F0FCFC' }}
          >
            {reports?.map((report) => (
              <MenuItem key={report.id} value={report.id} sx={{ fontSize: '14px' }}>
                <span className="text-[14px] text-[#363636]">
                  {moment(report.updatedAt).format('YYYY.MM.DD')}
                </span>
              </MenuItem>
            ))}
          </Select>
        )}
      </div>
      <div className="w-full h-[48px] flex items-center justify-between">
        <button
          type="button"
          onClick={() => setTab(TabCase.Result)}
          style={
            tab === TabCase.Result
              ? { background: '#fff', color: '#363636' }
              : { background: '#F8F8F8', color: '#bfbfbf' }
          }
          className="grow h-full flex justify-center items-center text-[16px] font-[600] bg-[#FFF] rounded-tl-[24px] rounded-tr-[24px]"
        >
          {t('report.header.analysis_result')}
        </button>
        <button
          type="button"
          onClick={() => {
            if (reports?.filter((report) => report.isSuccess)?.length < 2) {
              setAlertOpen(true);
            } else {
              setTab(TabCase.Change);
            }
          }}
          style={
            tab === TabCase.Change
              ? { background: '#fff', color: '#363636' }
              : { background: '#F8F8F8', color: '#bfbfbf' }
          }
          className="grow h-full flex justify-center text-[16px] font-[600] items-center bg-[#F8F8F8] rounded-tl-[24px] rounded-tr-[24px]"
        >
          {t('report.header.growth_change')}
        </button>
        <OneBtnAlert
          open={alertOpen}
          onClose={() => setAlertOpen(false)}
          title={t('report.header.alert_comparison_fail_title')}
          description={t('report.header.alert_comparison_fail_desc')}
          btnText={t('common.confirm')}
          onClick={() => setAlertOpen(false)}
        />
      </div>
      {tab === TabCase.Result ? (
        <div className="w-full min-h-[150px] flex flex-col items-start justify-start pb-[10px] pt-[30px] px-[20px] bg-[#fff]">
          <div className="text-left font-[700] text-[24px] text-[#363636] mb-[8px]">
            <span className="">{user?.mainKid?.kidName}</span>
            {t('report.header.main_title_suffix')}
            <br />
            {t('report.header.main_title_desc')}
          </div>
          <div className="text-[14px] text-left font-[400] text-[#767676]">
            {t('report.header.last_modified')} {moment(reports[0]?.updatedAt).format('YYYY.MM.DD')}
          </div>
          {shouldShowMoreVideo && (
            <div className="w-full bg-[#F0FCFC] py-[16px] px-[20px] rounded-[16px] mt-[16px]">
              <div className="w-full flex items-center justify-start gap-[8px] mb-[8px]">
                <img src={IcAlert} alt="alert" className="w-[24px] h-[24px]" />
                <div className="font-[700] text-[16px]">{t('report.header.guide_title')}</div>
              </div>
              <div className="font-[400] text-[12px] text-left">
                {t('report.header.guide_desc')}
              </div>
            </div>
          )}
          {shouldShowLackVideo && (
            <div
              className="w-full bg-[#ffebeb] py-[16px] px-[20px] rounded-[16px] mt-[16px] flex flex-col gap-[8px]"
              style={{ boxShadow: '0px 0px 10px 0px rgba(29, 32, 32, 0.07)' }}
            >
              <div className="w-full flex items-center justify-start gap-[4px] h-[24px]">
                <img src={IcAlertRed} alt="alert" className="w-[24px] h-[24px]" />
                <div className="font-[700] text-[16px] mt-[2px] text-[#1c1c1c]">
                  {t('report.header.insufficient_title')}
                </div>
              </div>
              <div className="font-[400] text-[12px] text-[#363636] text-left leading-[1.6]">
                {t('report.header.insufficient_desc')}
              </div>
            </div>
          )}
        </div>
      ) : (
        <div className="w-full min-h-[150px] flex flex-col items-start justify-start pb-[10px] pt-[30px] px-[20px] bg-[#fff]">
          <div className="text-left flex items-center justify-start gap-1 font-[700] text-[24px] text-[#363636]">
            <div className="">
              {user?.mainKid?.kidName}
              {t('report.header.main_title_suffix')}
            </div>
            {changeToggle === ComparisonType.Previous && (
              <Select
                variant="outlined"
                value={lastReportId || ''}
                onChange={(e) => setLastReportId(e.target.value)}
                IconComponent={KeyboardArrowDownIcon}
                sx={{
                  ...SELECT_STYLE,
                  backgroundColor: '#F0FCFC',
                  minWidth: '110px',
                  fontWeight: 600,
                }}
              >
                {filteredReports?.map((report) => (
                  <MenuItem key={report.id} value={report.id} sx={{ fontSize: '14px' }}>
                    <span className="text-[14px] text-[#363636]">
                      {moment(report?.updatedAt).format('YYYY.MM.DD')}
                    </span>
                  </MenuItem>
                ))}
              </Select>
            )}
          </div>
          <div className="text-left font-[700] text-[24px] text-[#363636] mb-[8px]">
            {changeToggle === ComparisonType.Previous
              ? t('report.header.comparison_previous_result')
              : t('report.header.comparison_cumulative_result')}
          </div>
          <div className="text-[14px] text-left font-[400] text-[#767676]">
            {t('report.header.last_modified')} {moment(reports[0]?.updatedAt).format('YYYY.MM.DD')}
          </div>
        </div>
      )}
    </div>
  );
}

export default Header;
